import { Button } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { FC } from "react";
import * as S from "./style.styled";

type Preset = {
  label: string;
  getRange: () => [Dayjs, Dayjs];
};

type PresetDatePickerProps = {
  activePreset: number;
  setActivePreset: (index: number) => void;
  onRangeChange: (range: [Dayjs, Dayjs]) => void;
};

const presets: Preset[] = [
  {
    label: "Сегодня",
    getRange: () => {
      const today = dayjs();
      return [today, today];
    },
  },
  {
    label: "Вчера",
    getRange: () => {
      const yesterday = dayjs().subtract(1, "day");
      return [yesterday, yesterday];
    },
  },

  {
    label: "Неделя",
    getRange: () => [dayjs().startOf("week"), dayjs().endOf("week")],
  },
  {
    label: "Месяц",
    getRange: () => [dayjs().startOf("month"), dayjs().endOf("month")],
  },
  {
    label: "Квартал",
    getRange: () => [dayjs().startOf("quarter"), dayjs().endOf("quarter")],
  },
];

const PresetDatePicker: FC<PresetDatePickerProps> = ({
  activePreset,
  setActivePreset,
  onRangeChange,
}) => {
  const handleClick = (index: number) => {
    setActivePreset(index);
    onRangeChange(presets[index].getRange());
  };

  return (
    <S.Wrapper>
      {presets.map((p, i) => (
        <Button
          key={p.label}
          type={i === activePreset ? "default" : "text"}
          onClick={() => handleClick(i)}
        >
          {p.label}
        </Button>
      ))}
    </S.Wrapper>
  );
};

export default PresetDatePicker;
